import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import i18n from './i18n';
import { store, persistor } from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/index.css';
import App from './App';
import ReactGA from 'react-ga';
import { GA_TRACKING_CODE } from './constants';

i18n();
ReactGA.initialize(GA_TRACKING_CODE);

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
);
